__turbopack_context__.v({
  "box": "RelatedTools-module__eny0Eq__box",
  "heading": "RelatedTools-module__eny0Eq__heading",
  "intro": "RelatedTools-module__eny0Eq__intro",
  "link": "RelatedTools-module__eny0Eq__link",
  "list": "RelatedTools-module__eny0Eq__list",
  "section": "RelatedTools-module__eny0Eq__section",
});
